import { X } from 'lucide-react';

import {
  readingLabel,
  scaleReadingLabel,
} from './kioskFormatters';

export function RequestLoadModal({
  isOpen,
  mode,
  selectedRegisterId,
  latestScannerReading,
  latestScaleReading,
  openRequestLoads,
  acceptLoadId,
  onAcceptLoadChange,
  confirmState,
  onAssignExistingLoadAndAccept,
  requestLoadForm,
  onRequestLoadFormChange,
  availableOutboundRequestLoads,
  displayedRequestLoadName,
  requestLoadActionState,
  registerOperationBlocker,
  onSubmit,
  onClose,
}) {
  if (!isOpen) {
    return null;
  }

  const isAcceptMode = mode === 'accept';
  const acceptLoadPlaceholder = openRequestLoads.length === 0
    ? 'ไม่มีโหลดที่เปิดอยู่'
    : 'เลือกโหลดที่เปิดอยู่';

  const directionField = (
    <div className="kiosk-field">
      <fieldset
        className="kiosk-direction-field kiosk-direction-field-disabled"
        aria-label="Request load direction"
        aria-disabled="true"
        disabled
        style={{ marginTop: '0.65rem' }}
      >
        <label className="kiosk-toggle-field">
          <input
            type="radio"
            name="direction"
            value="Outbound"
            checked={requestLoadForm.direction === 'Outbound'}
            disabled
          />
          ขาออก
        </label>
        <label className="kiosk-toggle-field">
          <input
            type="radio"
            name="direction"
            value="Inbound"
            checked={requestLoadForm.direction === 'Inbound'}
            disabled
          />
          ขาเข้า
        </label>
      </fieldset>
    </div>
  );

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
        zIndex: 1000,
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          position: 'relative',
          width: 'min(100%, 520px)',
          background: '#fff',
          borderRadius: '24px',
          padding: '1.5rem',
          boxShadow: '0 20px 70px rgba(15, 23, 42, 0.25)',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            width: '2.25rem',
            height: '2.25rem',
            zIndex: 1,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            border: '1px solid #cbd5e1',
            borderRadius: '50%',
            background: '#fff',
            color: '#0f172a',
            cursor: 'pointer',
            boxShadow: '0 2px 6px rgba(15, 23, 42, 0.12)',
          }}
        >
          <X aria-hidden="true" size={20} strokeWidth={2.5} />
        </button>

        <div>
          <h3 style={{ margin: 0, paddingRight: '2.75rem' }}>
            {isAcceptMode ? 'เลือกใบจองและยืนยัน' : 'สร้างคำขอโหลดใหม่'}
          </h3>
          <p style={{ margin: '0.35rem 0 0', color: '#466a7d', fontWeight: 700 }}>
            Register: {selectedRegisterId || 'ไม่มีการเลือก'}
          </p>
        </div>

        {isAcceptMode ? (
          <>
            <div className="kiosk-reading-grid">
              <article className="kiosk-reading-card">
                <span className="kiosk-reading-tag">สแกนเนอร์</span>
                <div className="kiosk-reading-value">{readingLabel(latestScannerReading)}</div>
              </article>
              <article className="kiosk-reading-card">
                <span className="kiosk-reading-tag">เครื่องชั่ง</span>
                <div className="kiosk-reading-value">{scaleReadingLabel(latestScaleReading)}</div>
              </article>
            </div>

            {directionField}

            <label className="kiosk-field">
              <select
                value={acceptLoadId}
                onChange={(event) => onAcceptLoadChange(event.target.value)}
                disabled={openRequestLoads.length === 0}
              >
                <option value="">{acceptLoadPlaceholder}</option>
                {openRequestLoads.map((requestLoad) => (
                  <option key={requestLoad.loadId} value={requestLoad.loadId}>
                    {requestLoad.name}
                  </option>
                ))}
              </select>
            </label>

            <div className="kiosk-actions">
              <button
                type="button"
                className="kiosk-primary-btn"
                disabled={!acceptLoadId || confirmState.type === 'pending'}
                onClick={onAssignExistingLoadAndAccept}
              >
                เลือกใบจองและยืนยัน
              </button>
            </div>
            {confirmState.message ? (
              <p className={`kiosk-feedback kiosk-feedback-${confirmState.type}`}>
                {confirmState.message}
              </p>
            ) : null}
          </>
        ) : (
          <>
            {directionField}

            <div className="kiosk-request-load-form-grid">
              <label className="kiosk-field">
                <span>สร้างโดย</span>
                <input
                  name="createdBy"
                  value={requestLoadForm.createdBy}
                  readOnly
                  placeholder="ชื่อผู้ปฏิบัติงาน"
                />
              </label>
            </div>

            {requestLoadForm.direction === 'Inbound' ? (
              <label className="kiosk-field">
                <span>โหลดขาออกที่เชื่อมโยง</span>
                <select
                  name="linkedOutboundLoadId"
                  value={requestLoadForm.linkedOutboundLoadId}
                  onChange={onRequestLoadFormChange}
                  disabled={availableOutboundRequestLoads.length === 0}
                >
                  <option value="">
                    {availableOutboundRequestLoads.length === 0
                      ? 'ไม่มีโหลดขาออกที่สามารถเชื่อมโยงได้'
                      : 'เลือกโหลดขาออกที่จะเชื่อมโยง'}
                  </option>
                  {availableOutboundRequestLoads.map((requestLoad) => (
                    <option key={requestLoad.loadId} value={requestLoad.loadId}>
                      {requestLoad.name}
                    </option>
                  ))}
                </select>
              </label>
            ) : null}

            <label className="kiosk-field">
              <span>ชื่อโหลด</span>
              <input
                name="name"
                value={displayedRequestLoadName}
                onChange={onRequestLoadFormChange}
                placeholder={requestLoadForm.direction === 'Inbound'
                  ? 'Optional suffix for this inbound load'
                  : 'e.g. April outbound transfer'}
              />
            </label>

            <label className="kiosk-field">
              <span>หมายเหตุ</span>
              <textarea
                name="notes"
                value={requestLoadForm.notes}
                onChange={onRequestLoadFormChange}
                placeholder="หมายเหตุเพิ่มเติมสำหรับโหลดนี้"
                rows={3}
              />
            </label>

            {requestLoadActionState.message ? (
              <p className={`kiosk-feedback kiosk-feedback-${requestLoadActionState.type}`}>
                {requestLoadActionState.message}
              </p>
            ) : null}

            <div className="kiosk-actions">
              <button
                type="submit"
                className="kiosk-primary-btn"
                disabled={requestLoadActionState.type === 'pending' || Boolean(registerOperationBlocker)}
              >
                {requestLoadActionState.type === 'pending'
                  ? 'Creating...'
                  : isAcceptMode
                    ? 'Create load and accept'
                    : 'Create request load'}
              </button>
              <button
                type="button"
                className="kiosk-secondary-btn"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
